// 学生答案页面
const AnswerLayout = (r) => require(['@/pages/exam/answer/student-answer/layout'], r)
const ExamStudentAnswer = (r) => require(['@/pages/exam/answer/student-answer/studentAnswer'], r) // 学生答案页面
const ExamBatchDoubt = (r) => require(['@/pages/exam/answer/student-answer/batchDoubtView'], r) // 疑问项页面
const ExamScanBatch = (r) => require(['@/pages/exam/answer/student-answer/scanBatch'], r) // 批阅页面

export default {
  path: '/region/exam/answer',
  component: AnswerLayout,
  meta: { auth: 'Region-Exam-Answer',},
  children: [
    {
      path: "/region/exam/answer/student-answer/:id",
      name: 'StudentAnswer',
      component: ExamStudentAnswer
    },
    {
      path: "/region/exam/answer/scan-batch/:id",
      name: 'ExamScanBatch',
      component: ExamScanBatch
    },
    {
      path: "/region/exam/answer/batch-doubt/:id",
      name: 'ExamBatchDoubt',
      component: ExamBatchDoubt
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/answer.js